import React from 'react';

// Nexus Core (DESIGN.md §6) - アンダーラインタイプ Select
// Input と同じく .underline-input::after で中央から広がるフォーカスライン
export default function Select({
  label,
  error,
  required,
  options = [],
  placeholder,
  className = '',
  wrapperClassName = '',
  ...props
}) {
  const selectId = props.id || props.name || `select-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className={`leading-normal ${wrapperClassName}`}>
      {label && (
        <label htmlFor={selectId} className="block text-xs text-text-secondary mb-1.5">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <div
        className={`underline-input relative rounded-t-md transition-colors hover:bg-light-neutral focus-within:bg-light-neutral ${
          error ? 'underline-input-error' : ''
        }`}
      >
        <select
          id={selectId}
          className={`
            appearance-none block w-full pl-3 pr-10 py-2.5 text-sm text-text-primary
            bg-transparent border-b transition-colors
            focus:outline-none
            disabled:opacity-60 disabled:cursor-not-allowed
            ${error ? 'border-red-400' : 'border-border-light'}
            ${className}
          `}
          {...props}
        >
          {placeholder && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {options.map((option) => (
            <option key={option.value} value={option.value} disabled={option.disabled}>
              {option.label}
            </option>
          ))}
        </select>
        <span className="material-symbols-outlined absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-outline text-[18px]">
          expand_more
        </span>
      </div>
      {error && (
        <p className="mt-1.5 text-xs text-red-600">{error}</p>
      )}
    </div>
  );
}
